import {css} from "@panda/css";

import {TextareaField} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

export const LeadFormMessageSlot = () => {
    return (
        <>
            <Text variant="body_copy_2" mb={1}>
                Wiadomość:
            </Text>
            <TextareaField className={css({mb: 3})} name="message" placeholder="Wpisz wiadomość do dewelopera." rows={6} />
        </>
    );
};
